import { atom, selector } from "recoil"

const audienceTotalCountAtom = atom({
  key: "audienceTotalCountAtom",
  default: 0
})

export const audienceTotalCountSelector = selector<number>({
  key: "audienceTotalCountSelector",
  get: ({ get }) => {
    return get(audienceTotalCountAtom)
  },
  set: ({ set }, count) => {
    set(audienceTotalCountAtom, count)
  }
})

const broadcasterTotalCountAtom = atom({
  key: "broadcasterTotalCountAtom",
  default: 0
})

export const broadcasterTotalCountSelector = selector<number>({
  key: "broadcasterTotalCountSelector",
  get: ({ get }) => {
    return get(broadcasterTotalCountAtom)
  },
  set: ({ set }, count) => {
    set(broadcasterTotalCountAtom, count)
  }
})

const moderatorTotalCountAtom = atom({
  key: "moderatorTotalCountAtom",
  default: 0
})

export const moderatorTotalCountSelector = selector<number>({
  key: "moderatorTotalCountSelector",
  get: ({ get }) => {
    return get(moderatorTotalCountAtom)
  },
  set: ({ set }, count) => {
    set(moderatorTotalCountAtom, count)
  }
})
